import React, { useRef, useState, useEffect } from "react";
import { BellOutline } from "antd-mobile-icons";
import { Tabs, Input, Button} from "antd-mobile-v5";
import { QRCodeCanvas } from "qrcode.react";
import "./subjectBindType.scss";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { ApiCore } from "../../api";
import backBtn from "../../static/icon/back_button.png";

const api = new ApiCore();

const SubjectBindType = (props: RouteComponentProps<{ subjectCode: string }>) => {
  const { subjectCode } = props.match.params;

  const [bindType, setBindType] = useState<"wx" | "msg">("wx");
  const [codeURL, setCodeURL] = useState<string>("");
  //受试者名称
  const targetName = sessionStorage.getItem('targetName') || '受试者';
  //悬浮按钮项相关
  let oLeft: any;
  let oTop: any;
  let moving: boolean = false;
  let oW: any;
  let oH: any;
  let htmlWidth: any;
  let htmlHeight: any;
  let bWidth: any;
  let bHeight: any;
  let click: boolean = false;
  useEffect(() => {
    let ele = document.getElementById("t-suspend-button");
    let recordStateLocal = localStorage.getItem("recordState");
    if (ele) {
      if (recordStateLocal) {
        let recordState = JSON.parse(recordStateLocal);
        ele.style.left = recordState.actionBall.left;
        ele.style.top = recordState.actionBall.top;
      }
      ele.addEventListener(
        "touchmove",
        (e) => {
          if (e.cancelable) {
            e.preventDefault();
          }
        },
        {
          passive: false,
        }
      );
    }
  }, []);
  //当开始触摸
  const onTouchStart = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = true;
    if (ele) {
      ele.style.opacity = "1";
      oW = e.clientX - ele?.getBoundingClientRect().left;
      oH = e.clientY - ele?.getBoundingClientRect().top;
      htmlWidth = document.documentElement.clientWidth;
      htmlHeight = document.documentElement.clientHeight;
      bWidth = ele.offsetWidth;
      bHeight = ele.offsetHeight;
      oLeft = e.clientX - oW;
      oTop = e.clientY - oH;

      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
      moving = true;
    }
  };

  //当触摸结束
  const onTouchEnd = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    moving = false;

    // 左侧距离
    let oLeft1 = oLeft;
    if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
      oLeft1 = 0;
    } else {
      oLeft1 = `${htmlWidth - bWidth}px`;
    }
    oLeft = oLeft1;
    if (ele) {
      ele.style.left = oLeft;
      let recordState = {
        actionBall: {
          left: ele.style.left,
          top: ele.style.top,
        },
      };
      localStorage.setItem("recordState", JSON.stringify(recordState));
      setTimeout(() => {
        if (ele) {
          ele.style.opacity = "0.8";
        }
      }, 2000);
    }
  };

  // 当开始触摸
  const onTouchMove = (e: any) => {
    moving && onMove(e);
  };

  // 当触摸
  const onMove = (e: any) => {
    let ele = document.getElementById("t-suspend-button");
    e = e.touches[0];
    click = false;

    // 左侧距离
    let oLeft1 = e.clientX - oW;
    let oTop1 = e.clientY - oH;
    if (oLeft1 < 0) {
      oLeft1 = 0;
    } else if (oLeft1 > htmlWidth - bWidth) {
      oLeft1 = htmlWidth - bWidth;
    }
    if (oTop1 < 0) {
      oTop1 = 0;
    } else if (oTop1 > htmlHeight - bHeight) {
      oTop1 = htmlHeight - bHeight;
    }
    oLeft = oLeft1;
    oTop = oTop1;
    if (ele) {
      ele.style.left = oLeft + "px";
      ele.style.top = oTop + "px";
    }
  };

  useEffect(() => {
    document.title = `${targetName}绑定`
    if (!subjectCode) return;
    getWxCode(subjectCode);
  }, [subjectCode]);

  const getWxCode = async (subjectCode: string) => {
    try {
      const doctorName = JSON.parse(sessionStorage.getItem("token") ?? "{}")?.userName;
      if (!doctorName) return;
      const result = await api.getSubjectBinding({ subjectCode, doctorName });
      setCodeURL(result?.data?.scanCodeUrl);
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return subjectCode ? (
    <div className={ bindType=='wx'?'bind-type--container':'bind-type--msg'}>
      <div className="bind-type--tabs">
        <Tabs activeKey={bindType}   onChange={(key:any) => { setBindType(key)}}>
          <Tabs.Tab title="微信扫码邀请" key="wx"></Tabs.Tab>
          {/* <Tabs.Tab title="短信邀请" key="msg"></Tabs.Tab> */}
        </Tabs>
      </div>
      {bindType === "wx" && (
        <div className="bind-type--wx">
          <div className="bind-type--tips">请让{targetName}/家属使用微信扫一扫进行绑定操作</div>
          <div className="bind-type--code">
            <div className="border_corner border_corner_left_top"></div>
            <div className="border_corner border_corner_right_top"></div>
            <div className="border_corner border_corner_left_bottom"></div>
            <div className="border_corner border_corner_right_bottom"></div>
            {!!codeURL && <QRCodeCanvas className="bind-type--img" value={codeURL} />}
          </div>
          <div className="bind-type--remind">
            <BellOutline className="icon" />
            绑定时提醒{targetName}/家属勾选小程序提醒
          </div>
        </div>
      )}
      {
        bindType === "msg" && (
          <div>
            <div className="msg-phone">
              <div className="msg-phone-label">手机号</div>
              <div  className="msg-phone-input">
                 <Input placeholder="请输入手机号" type="number"  style={{"--font-size":'14px'}}/>
              </div>
            
            </div>
            <div className="btn-bottom">
              <Button  className="btn-bottom-content" color='primary'  shape='rounded' >邀请</Button>
      
              </div>
          </div>
        )
      }
      <div
        className="addAction"
        id="t-suspend-button"
        onTouchStart={(e) => onTouchStart(e)}
        onTouchMove={(e) => onTouchMove(e)}
        onTouchEnd={(e) => onTouchEnd(e)}
      >
        <img
          src={backBtn}
          alt="back"
          onClick={() => {
            props.history.go(-1);
          }}
        />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default withRouter(SubjectBindType);
